export const DIRECTIONS = {
  Incoming: 'incoming',
  Outgoing: 'outgoing',
};

export const COMMUNICATIONS_MS_SEND_OPTIONS = [
  'recurring_send',
  'scheduled_send'
]

export const TEXT_ERROR_TYPES = {
  'SMS Not Delivered': '30007 Text undelivered',
  'SMS Invalid Mobile Number': 'SMS Invalid Mobile Number',
};

export const TEXT_CUSTOM_ERROR_TITLE = 'Text Failed To Send';

// SMS Opt-in Statuses
export const NOT_REQUESTED = 'not_requested';
export const APPROVED = 'approved';
export const PENDING = 'pending';
export const DENIED = 'denied';
export const IS_BULK = 'is bulk';


export const TEXT_TAB = 'communications.text';
export const TEXT_MANAGEMENT_TAB = 'communications.text.text-management';
